import Win2kButton from "@/components/win2k/Win2kButton";

interface GameControlsProps {
  isMyTurn: boolean;
  canStay: boolean;
  flipThreeRemaining: number;
  onHit: () => void;
  onStay: () => void;
}

export default function GameControls({
  isMyTurn,
  canStay,
  flipThreeRemaining,
  onHit,
  onStay,
}: GameControlsProps) {
  const hitLabel = flipThreeRemaining > 0 ? `Flip ${flipThreeRemaining}` : "Hit";

  return (
    <div className="flex gap-2 justify-center">
      <Win2kButton
        disabled={!isMyTurn}
        onClick={onHit}
        className="min-w-[80px]"
      >
        {hitLabel}
      </Win2kButton>
      <Win2kButton
        disabled={!isMyTurn || !canStay}
        onClick={onStay}
        className="min-w-[80px]"
      >
        Stay
      </Win2kButton>
    </div>
  );
}
